import { useEffect } from 'react';
import i18n from 'i18next';

import { useAllCustomProperties } from '@/components/custom-properties/use-custom-properties';
import { useAllCustomPropertyTypes } from '@/components/custom-properties/use-custom-property-types';

export const getCustomTypeTranslationKey = (
  typeName: string,
  value: string
) => {
  return `custom-types:${typeName}.${value}`;
};

export const getCustomPropertyTranslationKey = (propertyName: string) => {
  return `custom-properties:${propertyName}`;
};

/**
 * This hook will load all the translations for all current and future custom properties and types.
 * Can be paired to use with
 */
export const usePopulateCustomPropertiesTranslationsAndTypes = () => {
  const { data: properties } = useAllCustomProperties();
  const { data: propertyTypes } = useAllCustomPropertyTypes();

  useEffect(() => {
    if (properties) {
      properties.forEach((property) => {
        const displayName = property.displayNames?.find(
          (displayName) => displayName.language === i18n.language
        );

        if (displayName) {
          i18n.addResourceBundle(i18n.language, 'custom-properties', {
            [property.name]: displayName.value,
          });
        }
      });
    }
  }, [properties, i18n.language]);

  useEffect(() => {
    if (propertyTypes) {
      propertyTypes.forEach((type) => {
        const typeValues = Object.fromEntries(
          type.values
            ?.map((value) => {
              const displayName = value.displayNames?.find(
                (displayName) => displayName.language === i18n.language
              );

              if (!displayName) {
                return null;
              }

              return [value.value, displayName.value];
            })
            .filter((value) => value !== null) || []
        );

        if (typeValues) {
          i18n.addResourceBundle(i18n.language, 'custom-types', {
            [type.name]: typeValues,
          });
        }
      });
    }
  }, [propertyTypes, i18n.language]);
};
